








import { Component, Vue, Prop } from 'vue-property-decorator';

@Component({
	name: 'PageError',
})
export default class Error extends Vue {
	@Prop(String) private message!: string;
}
